import {
  EMPLOYEECONTRACT_LOADING,
  GET_EMPLOYEECONTRACT,
  GET_EMPLOYEECONTRACT_SUCCESS,
  GET_EMPLOYEECONTRACT_FAIL,
  ADD_EMPLOYEECONTRACT_SUCCESS,
  ADD_EMPLOYEECONTRACT_FAIL,
  DELETE_EMPLOYEECONTRACT_SUCCESS,
  DELETE_EMPLOYEECONTRACT_FAIL,
  UPDATE_EMPLOYEECONTRACT_SUCCESS,
  UPDATE_EMPLOYEECONTRACT_FAIL
} from "./actionType";

const INIT_STATE = {
  employeeContracts: [],
  error: {},
};

const EmployeeContract = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEECONTRACT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EMPLOYEECONTRACT:
          return {
            ...state,
            employeeContracts: action.payload.data,
            isEmployeeContractCreated: false,
            isEmployeeContractSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EMPLOYEECONTRACT_FAIL:
      switch (action.payload.actionType) {
        case GET_EMPLOYEECONTRACT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEmployeeContractCreated: false,
            isEmployeeContractSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EMPLOYEECONTRACT: {
      return {
        ...state,
        isEmployeeContractCreated: false,
        loading: true,
      };
    }

    case EMPLOYEECONTRACT_LOADING: {
      return {
        ...state,
        isEmployeeContractCreated: false,
        loading: true,
      };
    }

    case ADD_EMPLOYEECONTRACT_SUCCESS:
      return {
        ...state,
        isEmployeeContractCreated: true,
        loading: false,
        employeeContracts: [action.payload.data, ...state.employeeContracts],
      };

    case ADD_EMPLOYEECONTRACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EMPLOYEECONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeContracts: state.employeeContracts.filter(
          employeeContract => employeeContract.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EMPLOYEECONTRACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EMPLOYEECONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeContracts: state.employeeContracts.map(employeeContract =>
          employeeContract.id.toString() === action.payload.data.id.toString() ? { ...employeeContract, ...action.payload.data } : employeeContract
        ),
      };

    case UPDATE_EMPLOYEECONTRACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export default EmployeeContract;